
import { ACTIONS, URLS, STORAGE } from '../../_config';
import { ActionExtended } from '../../_config/interfaces/interfaces';

export interface UserReducer {
	store: any;
	branchDS: any;
	accessToken: string | null;
	refreshToken: string | null;
	isAuthenticated: boolean;
}

const initialState: UserReducer = {
	store: null,
	branchDS: null,
	accessToken: null,
	refreshToken: null,
	isAuthenticated: false,
};


const userReducer = (state = initialState, action: ActionExtended) => {
	switch (action.type) {
		case ACTIONS.USER.LOGIN:
			return {
				...state,
				accessToken: action.payload.accessToken,
				refreshToken: action.payload.refreshToken,
				isAuthenticated: true,
			};

		case ACTIONS.STORE.GET_STORE:
			return {
				...state,
				store: action.payload,
				isAuthenticated: true,
			};
		
		case ACTIONS.STORE.GET_BRANCH:
			return {
				...state,
				branchDS: action.payload,
				isAuthenticated: true,
			};

		case ACTIONS.USER.LOGOUT:
			return {
				...state,
				...initialState,
				// user: null,
				// accessToken: null,
				// isAuthenticated: false,
			};
		default:
			return state;
	}
};

export default userReducer;
